import React from 'react';

import { Transition } from 'semantic-ui-react';

export class Banner extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      nukeIt: false
    };
  }

  componentDidUpdate(prevProps, prevState) {
    /* fix persisting bluebar even when everything seems to say its hidden
     * --------------------------------------------------------------------
     * so basically it seems that the 'hide' dispatch is firing as the page exits,
     * then seems to fire again for some reason, which trips up the internal
     * mech of the `Transition` component, so if the incoming `isVisible` prop
     * is false, but it gets set to false a 2nd time, we fire off `nukeIt` to
     * just manually nuke the component, then we reset if `isVisible` changes again.
     */
    if (!prevProps.isVisible && !this.props.isVisible && !this.state.nukeIt) {
      this.setState({ nukeIt: true });
    } else if (this.state.nukeIt && this.props.isVisible) {
      this.setState({ nukeIt: false });
    }
  }

  render() {
    const { isVisible, message, type } = this.props;
    const delay = 500;
    const bannerMessage = message || BannerDefaultMessages.requestTimeout;
    const { nukeIt } = this.state;
    return !nukeIt ? (
      delay === 'none' ? (
        <BannerElement type={type} message={bannerMessage} />
      ) : (
        <Transition
          visible={isVisible}
          animation="fade"
          unmountOnHide={true}
          duration={delay}>
          <BannerElement type={type} message={bannerMessage} />
        </Transition>
      )
    ) : null;
  }
}

const BannerElement = ({ type, message }) => (
  <h1 className={['Banner', type || 'info'].filter((f) => !!f).join(' ')}>
    {message}
  </h1>
);

export const BannerDefaultMessages = {
  requestTimeout:
    'We are currently experiencing a high volume of activity. Please try again in a few minutes.'
};

export const BannerTypes = {
  info: 'info',
  warning: 'warning',
  error: 'error',
  maintenance: 'maintenance'
};

export default Banner;
